"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _loading_component = _interopRequireDefault(require("./component/loading_component"));

var _cover_loading_component = _interopRequireDefault(require("./component/cover_loading_component"));

var _colgroup = _interopRequireDefault(require("./component/colgroup"));

var _empty_component = _interopRequireDefault(require("./component/empty_component"));

var _tfoot_component = _interopRequireDefault(require("./component/tfoot_component"));

var _thead_component = _interopRequireDefault(require("./component/thead_component"));

var _tbody_component = _interopRequireDefault(require("./component/tbody_component"));

var _loading_tbody_component = _interopRequireDefault(require("./component/loading_tbody_component"));

var _table_compact_props = _interopRequireDefault(require("./table_compact_props"));

var _info = _interopRequireDefault(require("./info"));

var _index = require("./config/index");

var _index2 = require("./utils/index");

var _bool = require("./utils/bool");

var _set_size = require("./utils/set_size");

var _get_node = require("./utils/get_node");

var _classname = require("./utils/classname");

var _get_data = require("./utils/get_data");

var _set_position = require("./utils/set_position");

var _number = require("./utils/number");

var _get_size = require("./utils/get_size");

var _table_props = require("./table_props");

var _column_compact_props = _interopRequireDefault(require("./column_compact_props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var ieVersion = (0, _spauiUtils.getBrowserVersion)();
var ua = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && navigator ? navigator.userAgent.toLowerCase() : '';
var isFirefox = ua.indexOf('firefox') > -1;
var isSafari = ua.indexOf('safari') > -1 && ua.indexOf('chrome') < 0 && ua.indexOf('firefox') < 0 && ua.indexOf('compatible') < 0;
var isLowerIEEdge = ua.indexOf('Edge/18') > -1;

var classNameIndexOf = function classNameIndexOf(targetNode) {
  var classNameStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var result = -1;

  if (targetNode && typeof targetNode.className === 'string' && targetNode.className.indexOf && classNameStr) {
    result = targetNode.className.indexOf(classNameStr);
  }

  return result;
}; // 是否update时需要清空表格的宽度（如果前后的props是一致的，那就不要清空）


var isNeedClearTableWidth = function isNeedClearTableWidth() {
  var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = false; // 如果强制指定了不resize，在第二次update的时候不会做处理

  if (_typeof(prevProps) === 'object' && typeof prevProps.needResizeTableWidth !== 'undefined' && _typeof(nextProps) === 'object' && typeof nextProps.needResizeTableWidth !== 'undefined' && !nextProps.needResizeTableWidth) {
    return false;
  } // 目前需要借用window._的判断方法


  if (_typeof(prevProps) === 'object' && prevProps && _typeof(nextProps) === 'object' && nextProps && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window && window._ && window._.keys) {
    var _window = window,
        _ = _window._;

    if (_ && _.keys(prevProps).length === _.keys(nextProps).length) {
      var key = '';
      result = true;

      for (key in prevProps) {
        if (_typeof(prevProps[key]) !== _typeof(nextProps[key])) {
          result = false;
        } else if (key === 'children') {
          if ((0, _spauiUtils.isArray)(prevProps[key]) && (0, _spauiUtils.isArray)(nextProps[key])) {
            if (prevProps[key].length != nextProps[key].length) {
              result = false;
            }
          } else {
            result = false;
          }
        } else if (!(0, _spauiUtils.isFunction)(prevProps[key])) {
          // 扩展数据不影响整体的宽高
          if (!_.isEqual(prevProps[key], nextProps[key]) && key != 'expandOptions') {
            result = false;
          }
        }
      }
    }
  }

  return !result;
};
/**
 * @class
 */


var Table =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Table, _PureComponent);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));

    _this.nullList();

    _this.state = {
      filterSelectOpen: '',
      // 当前筛选打开的是哪个字段
      thClickFocusKey: '' // 哪一列的表头正在连续点击中

    };
    _this.bindScroll = _this.bindScroll.bind(_assertThisInitialized(_this));
    _this.handleWheel = _this.handleWheel.bind(_assertThisInitialized(_this));
    _this.handleDocumentWheel = _this.handleDocumentWheel.bind(_assertThisInitialized(_this));
    _this.handleTheadColumnMouseDown = _this.handleTheadColumnMouseDown.bind(_assertThisInitialized(_this));
    _this.handleThColumnMouseOver = _this.handleThColumnMouseOver.bind(_assertThisInitialized(_this));
    _this.handleThColumnMouseOut = _this.handleThColumnMouseOut.bind(_assertThisInitialized(_this));
    _this.handleColumnMouseMove = _this.handleColumnMouseMove.bind(_assertThisInitialized(_this));
    _this.handleTheColumnClick = _this.handleTheColumnClick.bind(_assertThisInitialized(_this));
    _this.handleColumnMouseUp = _this.handleColumnMouseUp.bind(_assertThisInitialized(_this));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_this));
    _this.handleWindowScroll = _this.handleWindowScroll.bind(_assertThisInitialized(_this));
    _this.handleFilterSelectOpen = _this.handleFilterSelectOpen.bind(_assertThisInitialized(_this)); // 表格最外层的观测器

    _this.tableContainerObserver = null;
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          scrollTarget = _this$props.scrollTarget,
          _this$props$needResiz = _this$props.needResizeObserver,
          needResizeObserver = _this$props$needResiz === void 0 ? true : _this$props$needResiz; // 触发一下属性跟事件

      this.triggerSetTableAttributeAndEvent(false); // 监听下页面变化

      if (_index2.haveJQuery) {
        jQuery(window).on('resize', this.handleWindowResize);
      } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
        window.addEventListener('resize', this.handleWindowResize);
      } // 监听下页面滚动


      if (_typeof(scrollTarget) === 'object' && scrollTarget) {
        scrollTarget.addEventListener('scroll', this.handleWindowScroll);
      } else {
        if (_index2.haveJQuery) {
          jQuery(window).on('scroll', this.handleWindowScroll);
        } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
          window.addEventListener('scroll', this.handleWindowScroll);
        }
      } // 监听滚轮


      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
        if (isFirefox) {
          window.addEventListener('DOMMouseScroll', this.handleDocumentWheel, {
            passive: false
          });
        } else {
          window.addEventListener('mousewheel', this.handleDocumentWheel, {
            passive: false
          });
        }
      } // 监听表格最外层的变化


      if (needResizeObserver && window.ResizeObserver && this.tableWrap) {
        var cssFixedTheadAble = (0, _bool.isFixedTableTheadByCss)(this.props);

        if (cssFixedTheadAble && this.tableTheadWraper) {
          this.theadWrapPosition = (0, _spauiUtils.getStyle)(this.tableTheadWraper, 'position');
        }

        this.tableContainerObserver = new window.ResizeObserver(function (entries) {
          if (!Array.isArray(entries) || !entries.length || !_this2.tableWrap) {
            return;
          }

          var newTableWrapWidth = (0, _number.toInt)((0, _spauiUtils.getStyle)(_this2.tableWrap, 'width')); // 上下滚动时，如果是表格固定头部切换时导致的，那么时不需要清空表格宽度的

          var prevTheadWrapPosition = _this2.theadWrapPosition;

          if (cssFixedTheadAble && _this2.tableTheadWraper) {
            _this2.theadWrapPosition = (0, _spauiUtils.getStyle)(_this2.tableTheadWraper, 'position');
          }

          var isChangeTheadWrapPosition = prevTheadWrapPosition !== _this2.theadWrapPosition; // 外层宽度没有变化，不执行任何操作

          if (_this2.tableWrapWidth === newTableWrapWidth && !isChangeTheadWrapPosition) {
            return;
          }

          _this2.tableWrapWidth = newTableWrapWidth;
          (0, _index2.nextAnimationFrame)(function () {
            // 拖动列的时候不响应这个内容（因为拖动列的时候，this.tableWrap的宽度本身就容易变更，会导致表格一直在resize）
            if (!_this2.adjustTarget && !_this2.isScrolling) {
              _this2.setTableAttributeAndEvent(true, !isChangeTheadWrapPosition);
            }
          });
        });
        this.tableContainerObserver.observe(this.tableWrap);
      }

      this.setFixedThead();
      this.setFixedTotal(); // 检查css与js版本

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          _this$props2$adjustWi = _this$props2.adjustWidthClassNameTrigger,
          adjustWidthClassNameTrigger = _this$props2$adjustWi === void 0 ? '' : _this$props2$adjustWi,
          _this$props2$adjustWi2 = _this$props2.adjustWidthClassName,
          adjustWidthClassName = _this$props2$adjustWi2 === void 0 ? '' : _this$props2$adjustWi2;

      if (this.tableWrap && typeof this.adjustTargetIndex === 'undefined' && adjustWidthClassNameTrigger === 'hover' && adjustWidthClassName && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document && document.querySelectorAll) {
        var adjustWidthClassNameDomList = document.querySelectorAll(".".concat(adjustWidthClassName));
        var adjustWidthClassNameDomListLen = adjustWidthClassNameDomList.length;
        var i = 0;

        if (adjustWidthClassNameDomListLen > 0) {
          for (; i < adjustWidthClassNameDomListLen; i++) {
            if (adjustWidthClassNameDomList[i]) {
              (0, _spauiUtils.removeClassName)(adjustWidthClassNameDomList[i], adjustWidthClassName);
            }
          }
        }
      } // 触发一下属性跟事件


      this.triggerSetTableAttributeAndEvent(true, prevProps);
      this.setFixedThead();
      this.setFixedTotal();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollTarget = this.props.scrollTarget;
      this.nullList(); // 销毁的时候必须去掉监听事件，不然性能越来越差

      if (_index2.haveJQuery) {
        jQuery(window).off('resize', this.handleWindowResize);
      } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.removeEventListener)) {
        window.removeEventListener('resize', this.handleWindowResize);
      }

      if (_typeof(scrollTarget) === 'object' && scrollTarget) {
        scrollTarget.removeEventListener('scroll', this.handleWindowScroll);
      } else {
        if (_index2.haveJQuery) {
          jQuery(window).off('scroll', this.handleWindowScroll);
        } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.removeEventListener)) {
          window.removeEventListener('scroll', this.handleWindowScroll);
        }
      }

      this.isScrolling = false;
      clearTimeout(this.scrollTimeout); // 监听滚轮

      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.removeEventListener)) {
        if (isFirefox) {
          window.removeEventListener('DOMMouseScroll', this.handleDocumentWheel, {
            passive: false
          });
        } else {
          window.removeEventListener('mousewheel', this.handleDocumentWheel, {
            passive: false
          });
        }
      } // 停止监听表格宽度的变化


      if (this.tableContainerObserver) {
        this.tableContainerObserver.disconnect();
      }
    } // 相关指引变量

  }, {
    key: "nullList",
    value: function nullList() {
      this.tableWrap = null;
      this.theadColGroup = null;
      this.tbodyColGroup = null;
      this.tfootColGroup = null;
      this.tableTheadWraper = null;
      this.tableTbodyWraper = null;
      this.tableTfootWraper = null;
      this.theadWrap = null;
      this.tbodyWrap = null;
      this.tfootWrap = null;
      this.theadTable = null;
      this.tbodyTable = null;
      this.thead = null;
      this.tbody = null;
      this.emptyDataNode = null;
      this.tfoot = null;
      this.title = null;
      this.triggerSetTableTimeout = null;
      this.scrollLeft = 0; // loading的外层结构

      this.loadingDiv = null; // scroll需要的内容

      this.wheelTargetTimeout = null;
      this.fixedCellList = [];
      this.fixedCellTimeout = null;
      this.isScrolling = false;
      this.scrollTimeout = null; // 宽度、高度相关

      this.tableWrapWidth = null; // 表格固定头部位置信息

      this.theadWrapPosition = '';
    } // 为bindScroll准备内容

  }, {
    key: "getScrollInfo",
    value: function getScrollInfo() {
      var children = this.props.children;
      var columns = (0, _get_node.getColumns)(children);

      var _getTableDOM = (0, _get_node.getTableDOM)(this),
          clientWidth = _getTableDOM.clientWidth;

      var getCellNodeByTr = function getCellNodeByTr(trNode) {
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var cellList = [];

        if (trNode) {
          cellList = trNode.getElementsByTagName('td');

          if (cellList.length < 1) {
            cellList = trNode.getElementsByTagName('th');
          }
        } // 如果有该class说明内置的结构是使用方自定义的，只取第一个数据


        if (classNameIndexOf(trNode, 'spaui-table-tr-expand') > -1 && cellList.length > 1) {
          cellList = [cellList[0]];
        }

        if (index < 0) {
          return cellList;
        }

        return trNode.querySelector("[data-index=\"".concat(index, "\"]")) || null;
      }; // 获取对应index的前后固定列信息


      var getFixedColumnData = function getFixedColumnData(index) {
        var unFixedColumnListBeforeIndex = [];
        var fixedColumnListAfterIndex = [];
        columns.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var columnIndex = arguments.length > 1 ? arguments[1] : undefined;

          var _columnCompactProps = (0, _column_compact_props["default"])(item.props || {}),
              fixedable = _columnCompactProps.fixedable;

          if (item) {
            // 获取index前不固定的列
            if (!fixedable && columnIndex < index) {
              unFixedColumnListBeforeIndex.push(columnIndex);
            } // 获取从index后fixed的列


            if (fixedable && columnIndex > index) {
              fixedColumnListAfterIndex.push(columnIndex);
            }
          }

          return item;
        });
        return {
          unFixedColumnListBeforeIndex: unFixedColumnListBeforeIndex,
          fixedColumnListAfterIndex: fixedColumnListAfterIndex
        };
      };

      var fixedCellList = [];

      if (this.tableWrap) {
        var trList = this.tableWrap.getElementsByTagName('tr') || [];
        var trListLen = trList.length; // 获取固定单元格数据，之后在统一更新

        columns.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var index = arguments.length > 1 ? arguments[1] : undefined;
          var columnProps = item.props || {};

          var _columnCompactProps2 = (0, _column_compact_props["default"])(columnProps),
              fixedable = _columnCompactProps2.fixedable,
              _columnCompactProps2$ = _columnCompactProps2.fixedClassName,
              fixedClassName = _columnCompactProps2$ === void 0 ? '' : _columnCompactProps2$;

          var columnCellList = []; // 列对应的单元格dom

          var trListIndex = 0;
          var trNode = null;
          var fixedColumnData = {};
          var getLeft;
          var haveGetCellLeft = false; // 非IE才支持固定列

          if (fixedable && trListLen > 0 && ieVersion < 0) {
            for (; trListIndex < trListLen; trListIndex++) {
              trNode = trList[trListIndex]; // 确认是自己的tr才加入到固定列

              if (trNode && trNode.getAttribute('data-spaui-table-tr')) {
                columnCellList.push(getCellNodeByTr(trNode, index)); // 获取单元格对应的left

                if (!haveGetCellLeft) {
                  fixedColumnData = getFixedColumnData(index);
                  getLeft = (0, _set_position.genGetCellLeftMethod)(index, getCellNodeByTr(trNode, -1), clientWidth, columnProps, fixedColumnData.unFixedColumnListBeforeIndex, fixedColumnData.fixedColumnListAfterIndex);
                  haveGetCellLeft = true;
                }
              }
            }

            if (columnCellList.length > 0) {
              fixedCellList.push({
                columnCellList: columnCellList,
                getLeft: getLeft,
                index: index,
                fixedClassName: fixedClassName
              });
            }
          }

          return item;
        });
        this.fixedCellList = fixedCellList;
      }
    } // 筛选下拉框切换

  }, {
    key: "handleFilterSelectOpen",
    value: function handleFilterSelectOpen(event, name, open) {
      this.setState({
        filterSelectOpen: open ? name : ''
      });
    } // 用于向实例提供内部node的节点引用

  }, {
    key: "getNode",
    value: function getNode() {
      return {
        tableWrap: this.tableWrap || null,
        tableTheadWraper: this.tableTheadWraper || null,
        tableTheadDiv: this.theadWrap || null,
        tableTbodyWraper: this.tableTbodyWraper || null,
        tableTbodyDiv: this.tbodyWrap || null,
        tableTfootWraper: this.tableTfootWraper || null,
        tableTfootDiv: this.tfootWrap || null
      };
    } // 保留方法

  }, {
    key: "getDOMNode",
    value: function getDOMNode() {
      return this.getNode().tableWrap;
    }
  }, {
    key: "getTheadWraperDOMNode",
    value: function getTheadWraperDOMNode() {
      return this.getNode().tableTheadWraper;
    }
  }, {
    key: "getTheadDiv",
    value: function getTheadDiv() {
      return this.getNode().tableTheadDiv;
    }
  }, {
    key: "getTbodyWraperDOMNode",
    value: function getTbodyWraperDOMNode() {
      return this.getNode().tableTbodyWraper;
    }
  }, {
    key: "getTbodyDiv",
    value: function getTbodyDiv() {
      return this.getNode().tableTbodyDiv;
    }
  }, {
    key: "getTfootWraperDOMNode",
    value: function getTfootWraperDOMNode() {
      return this.getNode().tableTfootWraper;
    }
  }, {
    key: "getTfootDiv",
    value: function getTfootDiv() {
      return this.getNode().tableTfootDiv;
    }
  }, {
    key: "getScrollLeft",
    value: function getScrollLeft() {
      return this.scrollLeft || 0;
    } // 处理resize就是重新设置内容

  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      this.setTableAttributeAndEvent(true);
    } // 页面滚动监听

  }, {
    key: "handleWindowScroll",
    value: function handleWindowScroll(event) {
      var _this3 = this;

      var cssFixedTheadAble = (0, _bool.isFixedTableTheadByCss)(this.props);

      var _this$getNode = this.getNode(),
          tableTheadWraper = _this$getNode.tableTheadWraper,
          tableTheadDiv = _this$getNode.tableTheadDiv,
          tableWrap = _this$getNode.tableWrap;

      var children = this.props.children;
      var scrollLeft = tableWrap && tableWrap.scrollLeft || 0;
      var tableTheadWraperPosition = '';

      if (cssFixedTheadAble) {
        if (cssFixedTheadAble && tableTheadWraper) {
          tableTheadWraperPosition = (0, _spauiUtils.getStyle)(tableTheadWraper, 'position');

          if (tableTheadWraperPosition) {
            if (tableTheadWraperPosition === 'fixed') {
              tableTheadDiv.style.position = 'relative';
            } else {
              if (scrollLeft === 0) {
                tableTheadDiv.style.position = 'relative';
              } else {
                tableTheadDiv.style.position = 'static';
              }
            }
          }
        }
      }

      this.setFixedTotal();
      this.setFixedThead(event);
      clearTimeout(this.scrollTimeout);
      this.isScrolling = true;
      this.scrollTimeout = setTimeout(function () {
        _this3.isScrolling = false;

        if (cssFixedTheadAble) {
          var tableWrapNode = _this3.tableWrap;

          if (tableWrapNode) {
            // 停止滚动的时候要重置下固定列，防止不对齐
            _this3.bindScroll({
              target: classNameIndexOf(tableWrapNode, _index.tableFixedTheadClassName) < 0 ? tableWrapNode : _this3.tableTbodyWraper
            }, (0, _get_node.getColumns)(children), true);
          }
        }
      }, 50);
    }
  }, {
    key: "getScrollTargetTop",
    value: function getScrollTargetTop() {
      var scrollTarget = this.props.scrollTarget;
      var result = 0;

      if (scrollTarget && scrollTarget.getBoundingClientRect) {
        result = scrollTarget.getBoundingClientRect().top || 0;
      }

      return result;
    }
  }, {
    key: "setFixedThead",
    value: function setFixedThead(event) {
      var _this$props3 = this.props,
          scrollTarget = _this$props3.scrollTarget,
          setCssFixedTheadSpace = _this$props3.setCssFixedTheadSpace,
          _this$props3$autoForC = _this$props3.autoForCssFixedThead,
          autoForCssFixedThead = _this$props3$autoForC === void 0 ? false : _this$props3$autoForC,
          _this$props3$theadAlw = _this$props3.theadAlwaysUseFixed,
          theadAlwaysUseFixed = _this$props3$theadAlw === void 0 ? false : _this$props3$theadAlw;
      var cssFixedTheadAble = (0, _bool.isFixedTableTheadByCss)(this.props);
      var cssFixedTheadSpace = (0, _spauiUtils.isFunction)(setCssFixedTheadSpace) ? setCssFixedTheadSpace() || 0 : 0;

      if (autoForCssFixedThead && scrollTarget && cssFixedTheadAble && this.tableWrap && this.tableTheadWraper) {
        // 页面滚动条
        var scrollTop = (0, _get_size.getScrollTop)(typeof scrollTarget === 'string' ? '' : scrollTarget);
        var tableRect = this.tableWrap.getBoundingClientRect(); // 表格距离顶部距离

        var tableWrap = this.tableWrap;
        var theadWrapTop = tableRect.top + 1 + scrollTop - this.getScrollTargetTop();
        var tableTheadWraper = this.tableTheadWraper;
        var tableTheadWraperReact = tableTheadWraper.getBoundingClientRect();
        var theadHeight = "".concat(tableTheadWraperReact.height, "px");

        if (tableRect.width === 0 && tableRect.height === 0) {
          return false;
        } // 滚动条还没到表格的位置，不固定表头


        if (scrollTop < theadWrapTop - cssFixedTheadSpace) {
          // static切换到fixed的时候会触发表格宽度变化，导致横向滚动条重置，增加fixed的模式看看，如果问题得到修复，默认就采用fixed
          if (!theadAlwaysUseFixed) {
            // 重置掉一些位置信息
            tableTheadWraper.style.overflow = ''; // 回复到表格的位置

            tableTheadWraper.style.position = 'static'; // 不留空间

            tableWrap.style.paddingTop = '0px';
          } else {
            // fixed的时候已经跳出页面布局了，所以要隐藏掉
            tableTheadWraper.style.overflow = 'hidden'; // 设置fixed

            tableTheadWraper.style.position = 'fixed'; // 位置置顶

            tableTheadWraper.style.top = "".concat(theadWrapTop - scrollTop, "px"); // fixed后，thead已经不见了，要给tbody保持点原来的距离

            tableWrap.style.paddingTop = theadHeight;
          }
        } else {
          // fixed的时候已经跳出页面布局了，所以要隐藏掉
          tableTheadWraper.style.overflow = 'hidden'; // 设置fixed

          tableTheadWraper.style.position = 'fixed'; // 位置置顶

          tableTheadWraper.style.top = "".concat(cssFixedTheadSpace + this.getScrollTargetTop(), "px"); // fixed后，thead已经不见了，要给tbody保持点原来的距离

          tableWrap.style.paddingTop = theadHeight;
        }

        this.setFixedTitle(event);
      }
    }
  }, {
    key: "setFixedTotal",
    value: function setFixedTotal() {
      var _this$props4 = this.props,
          scrollTarget = _this$props4.scrollTarget,
          setCssFixedTotalSpace = _this$props4.setCssFixedTotalSpace,
          autoForCssFixedTotal = _this$props4.autoForCssFixedTotal;
      var cssFixedTotalAble = (0, _bool.isFixedTableTotalByCss)(this.props);
      var cssFixedTotalSpace = 0; // 如果是window级别的滚动条会监听下页面滚动的方式
      // 固定总计

      if (autoForCssFixedTotal && scrollTarget && cssFixedTotalAble && this.tableWrap && this.tableTfootWraper) {
        // 窗口高度
        var winHeight = window.innerHeight;

        if ((0, _spauiUtils.isFunction)(setCssFixedTotalSpace)) {
          cssFixedTotalSpace = setCssFixedTotalSpace() || 0;
        } else {
          cssFixedTotalSpace = winHeight - winHeight / 3;
        } // 页面滚动条


        var scrollTop = (0, _get_size.getScrollTop)(typeof scrollTarget === 'string' ? '' : scrollTarget); // 获取对应的结构

        var tableTfootWraper = this.tableTfootWraper;
        var tableRect = this.tableWrap.getBoundingClientRect(); // 表格高度

        var tableHeight = tableRect.height; // 表格距离顶部距离

        var theadWrapTop = tableRect.top + 1 + scrollTop - this.getScrollTargetTop();

        if (tableRect.width === 0 && tableRect.height === 0) {
          return false;
        } // 对于total滚动条的，只需要关注啥时候fixed tfoot，啥时候隐藏
        // 表头的位置还没到屏幕的上半部分位置 或 已经见到footer了


        if (theadWrapTop >= scrollTop + cssFixedTotalSpace || theadWrapTop + tableHeight < scrollTop + winHeight + 10) {
          // 不展示
          tableTfootWraper.style.bottom = '9999px';
        } else {
          // 位置置底
          tableTfootWraper.style.bottom = '0px';
        }
      }
    }
  }, {
    key: "handleDocumentWheel",
    value: function handleDocumentWheel(event) {
      var _this$props$wheelPrev = this.props.wheelPreventDefault,
          wheelPreventDefault = _this$props$wheelPrev === void 0 ? false : _this$props$wheelPrev;
      var parentNode = (0, _spauiUtils.closest)(event.target, '.spaui-table');
      var isPreventDefault = (Math.abs(event.deltaX) > 0 || isFirefox && event.axis === 1) && this.tableWrap && parentNode === this.tableWrap;
      var scrollLeft = 0;
      var maxScrollLeft = 0;

      if (isPreventDefault) {
        // 使用隐藏滚动条的方式来固定列的，必须开启
        if (this.setCellFixedUseHideScrollBar()) {
          isPreventDefault = true;
        } else if (wheelPreventDefault && this.tableWrap) {
          scrollLeft = this.tableWrap.scrollLeft + event.deltaX;
          maxScrollLeft = this.tableWrap.scrollWidth - this.tableWrap.clientWidth;

          if (scrollLeft < 0 || scrollLeft > maxScrollLeft) {
            isPreventDefault = true;
          } else {
            isPreventDefault = false;
          }
        } else {
          isPreventDefault = false;
        }
      } // 在对应表格横向滚动的时候禁止下


      if (isPreventDefault) {
        if (event.stopPropagation) {
          event.stopPropagation();
        } else {
          event.cancelBubble = true;
        }

        if (event.preventDefault) {
          event.preventDefault();
        } else {
          event.returnValue = true;
        }
      }
    } // 设置页面宽度

  }, {
    key: "setWrapWidth",
    value: function setWrapWidth(width) {
      (0, _set_size.setNodeWidth)(this.theadWrap, width);
      (0, _set_size.setNodeWidth)(this.tbodyWrap, width);
      (0, _set_size.setNodeWidth)(this.tfootWrap, width);
    } // 设置loading结构的with

  }, {
    key: "setLoadingWidth",
    value: function setLoadingWidth(width) {
      var _this$props5 = this.props,
          hideScrollBar = _this$props5.hideScrollBar,
          loading = _this$props5.loading;
      var parentNode = null;
      var loadingDivWidth = 0;
      var space = 0;

      if (hideScrollBar && loading && this.loadingDiv && (0, _number.toInt)(width) > 0) {
        loadingDivWidth = (0, _number.toInt)((0, _spauiUtils.getStyle)(this.loadingDiv, 'width')); // 本身的结构大于表格的宽度才需要重新设置

        if (loadingDivWidth > (0, _number.toInt)(width)) {
          parentNode = this.loadingDiv.parentNode; // 需要看下父级是否有padding

          if (parentNode) {
            space += (0, _number.toInt)((0, _spauiUtils.getStyle)(parentNode, 'paddingLeft'));
            space += (0, _number.toInt)((0, _spauiUtils.getStyle)(parentNode, 'paddingRight'));
          }

          this.loadingDiv.style.width = "".concat((0, _number.toInt)(width) - space, "px");
        }
      }
    }
  }, {
    key: "handleTheadColumnMouseDown",
    value: function handleTheadColumnMouseDown(event) {
      var _getTableDOM2 = (0, _get_node.getTableDOM)(this),
          clientWidth = _getTableDOM2.clientWidth;

      var theadThs = (0, _get_node.getTableCellNodes)((this.theadTable || this.tbodyTable).getElementsByTagName('thead')[0], 'th', function (result) {
        var index = 0;

        if (result && result.length > 2) {
          index = result.length - 2;
        }

        return index;
      });
      var nextThData = {};
      var tableWidth = 0;

      if (event && event.target && classNameIndexOf(event.target, 'spaui-table-adjust-width-span') > -1 && (0, _bool.isAdjustWidth)(this)) {
        // 如果宽度是自动的或者百分百或者获取不到，就用表格最外的宽度
        if (this.tbodyWrap.style.width === 'auto' || this.tbodyWrap.style.width === '100%' || !this.tbodyWrap.style.width) {
          tableWidth = clientWidth;
        } else {
          tableWidth = parseFloat(this.tbodyWrap.style.width, 10) || 0;
        } // 记录对应的位置


        this.adjustWidthSpanLeft = event.pageX;
        this.adjustTarget = event.target.parentNode;
        this.adjustWidth = parseFloat((0, _spauiUtils.getStyle)(this.adjustTarget, 'width'), 10) || 0;
        nextThData = (0, _get_node.getNextTh)(this.adjustTarget, theadThs);
        this.adjustNextTarget = nextThData.nextTh;
        this.adjustTargetIndex = nextThData.index - 1;
        this.adjustNextTargetWidth = parseFloat((0, _spauiUtils.getStyle)(this.adjustNextTarget, 'width'), 10) || 0;
        this.tableWidth = tableWidth; // 给拖动的单元格加上对应的className

        (0, _classname.addClassNameForCell)(this.tableWrap, this.adjustTargetIndex, this.props.adjustWidthClassName || '');

        if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
          document.addEventListener('mousemove', this.handleColumnMouseMove);
          document.addEventListener('mouseup', this.handleColumnMouseUp);
        }
      }
    }
  }, {
    key: "handleColumnMouseMove",
    value: function handleColumnMouseMove(event) {
      var _this4 = this;

      var _this$props6 = this.props,
          adjustMinWidth = _this$props6.adjustMinWidth,
          adjustMaxWidth = _this$props6.adjustMaxWidth;

      var _compactProps = (0, _table_compact_props["default"])(this.props),
          cssFixedTheadAble = _compactProps.cssFixedTheadAble,
          _compactProps$data = _compactProps.data,
          data = _compactProps$data === void 0 ? [] : _compactProps$data;

      var fixedTableThead = (0, _bool.isFixedTableThead)(this.props);
      var fixedTableTotal = (0, _bool.isFixedTableTotalByCss)(this.props);

      var _getTableDOM3 = (0, _get_node.getTableDOM)(this),
          clientWidth = _getTableDOM3.clientWidth,
          tdTfoot = _getTableDOM3.tdTfoot;

      var dataAdjustMaxWidth = this.adjustTarget && (0, _number.toInt)(this.adjustTarget.getAttribute('data-adjustmaxwidth'));
      var theNodeMaxWidth = dataAdjustMaxWidth || (0, _number.toInt)(adjustMaxWidth || document.body.scrollWidth, 10);

      var adjustWidthForAttribute = function adjustWidthForAttribute(node, width) {
        var dataAdjustMinWidth = (0, _number.toInt)(node.getAttribute('data-adjustminwidth'));
        var theNodeMinWidth = dataAdjustMinWidth || (0, _number.toInt)(adjustMinWidth, 10);
        var minWidth = node.getAttribute('data-min-width') || 0;
        var maxWidth = node.getAttribute('data-max-width') || 0;
        var result = width; // 如果tfoot是不过行的，需要看看具体内容最少是多少

        if (tdTfoot && tdTfoot[_this4.adjustTargetIndex] && tdTfoot[_this4.adjustTargetIndex].innerText && (0, _spauiUtils.getStyle)(tdTfoot[_this4.adjustTargetIndex], 'white-space') === 'nowrap') {
          var curTdFootSize = (0, _get_size.getTextSize)(tdTfoot[_this4.adjustTargetIndex].innerText) || {
            width: 0,
            height: 0
          };

          if (curTdFootSize.width > 0 && curTdFootSize.width < theNodeMaxWidth && curTdFootSize.width > theNodeMinWidth) {
            theNodeMinWidth = curTdFootSize.width + 10;
          }
        }

        if (minWidth && result < minWidth) {
          result = minWidth;
        }

        if (maxWidth && result > maxWidth && !(cssFixedTheadAble && data.length < 1)) {
          result = maxWidth;
        }

        if (result < theNodeMinWidth) {
          result = theNodeMinWidth;
        }

        if (result > theNodeMaxWidth) {
          result = theNodeMaxWidth;
        }

        return result;
      };

      var theThWidth = 0;
      var tableWidth = 0;
      var space = 0;

      if (this.adjustWidthSpanLeft && this.adjustWidth && this.adjustTarget && this.adjustNextTarget) {
        space = event.pageX - this.adjustWidthSpanLeft;

        if (space !== 0) {
          theThWidth = adjustWidthForAttribute(this.adjustTarget, space + this.adjustWidth);
          this.adjustTarget.style.width = "".concat(theThWidth, "px");

          if (fixedTableThead || fixedTableTotal) {
            (0, _set_size.setCellWidthForTable)(this.adjustTargetIndex, theThWidth, false, 0, (0, _get_node.getTableDOM)(this), this.props);

            if (this.tableWidth) {
              // 没有超过拖动的最大值，可以继续拖动
              if (theThWidth < theNodeMaxWidth) {
                tableWidth = this.tableWidth + space;
              } else {
                tableWidth = (0, _spauiUtils.getStyle)(this.tbodyWrap, 'width') || this.tableWidth + space;
              }

              if (tableWidth < clientWidth) {
                tableWidth = clientWidth;
              }

              this.setWrapWidth(tableWidth);

              if (this.theadTable) {
                this.theadTable.style.width = "".concat(tableWidth, "px");
              }

              if (this.tbodyTable) {
                this.tbodyTable.style.width = "".concat(tableWidth, "px");
              }

              if (this.tfootTable) {
                this.tfootTable.style.width = "".concat(tableWidth, "px");
              }
            }
          } else {
            if (this.tableWidth) {
              // 没有超过拖动的最大值，可以继续拖动
              if (theThWidth < theNodeMaxWidth) {
                tableWidth = this.tableWidth + space;
              } else {
                tableWidth = (0, _spauiUtils.getStyle)(this.tbodyWrap, 'width') || this.tableWidth + space;
              }

              if (tableWidth < clientWidth) {
                tableWidth = '100%';
              } else if (this.tableWrap && classNameIndexOf(this.tableWrap, _index.tableScrollClassName) < 0) {
                this.tableWrap.className = "".concat(this.tableWrap.className, " ").concat(_index.tableScrollClassName);
              }

              (0, _set_size.setNodeWidth)(this.tbodyWrap, tableWidth);
            }
          }
        }
      }
    }
  }, {
    key: "handleColumnMouseUp",
    value: function handleColumnMouseUp(event) {
      var onColumnWidthChange = this.props.onColumnWidthChange;
      var theadThs = (0, _get_node.getTableCellNodes)((this.theadTable || this.tbodyTable).getElementsByTagName('thead')[0], 'th', function (result) {
        var index = 0;

        if (result && result.length > 2) {
          index = result.length - 2;
        }

        return index;
      });
      var result = {};
      var len = theadThs.length;
      var i = 0;

      if (this.adjustWidthSpanLeft && this.adjustWidth && this.adjustTarget && this.adjustNextTarget) {
        // 给对应的单元格去掉className
        (0, _classname.removeClassNameForCell)(this.tableWrap, this.adjustTargetIndex, this.props.adjustWidthClassName || ''); // 重置

        this.adjustWidthSpanLeft = 0;
        this.adjustWidth = 0;
        this.adjustNextTargetWidth = 0;
        this.adjustTarget = null;
        this.adjustNextTarget = null;
        this.adjustTargetIndex = -1;
        this.tableWidth = 0;

        for (; i < len; i++) {
          if (theadThs[i] && theadThs[i].getAttribute('data-name')) {
            result[theadThs[i].getAttribute('data-name')] = parseFloat((0, _spauiUtils.getStyle)(theadThs[i], 'width'), 10) || 0;
          }
        }

        if (onColumnWidthChange) {
          onColumnWidthChange(event, result);
        }
      } // 回收监听


      if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
        document.removeEventListener('mousemove', this.handleColumnMouseMove);
        document.removeEventListener('mouseup', this.handleColumnMouseUp);
      }
    }
  }, {
    key: "handleThColumnMouseOver",
    value: function handleThColumnMouseOver(event, index) {
      var columnProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _this$props7 = this.props,
          _this$props7$adjustWi = _this$props7.adjustWidthClassNameTrigger,
          adjustWidthClassNameTrigger = _this$props7$adjustWi === void 0 ? '' : _this$props7$adjustWi,
          _this$props7$adjustWi2 = _this$props7.adjustWidthClassName,
          adjustWidthClassName = _this$props7$adjustWi2 === void 0 ? '' : _this$props7$adjustWi2; // 如果是可拖动的列，指定hover的时候展示拖动class

      if (columnProps.adjustWidth) {
        if (adjustWidthClassNameTrigger === 'hover') {
          // 如果有拖动index，必须跟拖动index相等才可以
          if (typeof this.adjustTargetIndex === 'undefined' || this.adjustTargetIndex < 0 || this.adjustTargetIndex === index) {
            (0, _classname.addClassNameForCell)(this.tableWrap, index, adjustWidthClassName);
          }
        }
      }
    }
  }, {
    key: "handleThColumnMouseOut",
    value: function handleThColumnMouseOut(event, index, columnProps) {
      var _this$props8 = this.props,
          _this$props8$adjustWi = _this$props8.adjustWidthClassNameTrigger,
          adjustWidthClassNameTrigger = _this$props8$adjustWi === void 0 ? '' : _this$props8$adjustWi,
          _this$props8$adjustWi2 = _this$props8.adjustWidthClassName,
          adjustWidthClassName = _this$props8$adjustWi2 === void 0 ? '' : _this$props8$adjustWi2; // 如果是可拖动的列，指定hover的时候去除拖动class

      if (columnProps.adjustWidth) {
        // 如果在拖动中就不响应这个了
        if (adjustWidthClassNameTrigger === 'hover' && !this.adjustTarget) {
          (0, _classname.removeClassNameForCell)(this.tableWrap, index, adjustWidthClassName);
        }
      }

      if (this.props.thClickFocusClassName) {
        this.setState({
          thClickFocusKey: ''
        });
      }
    } // 点击表头th

  }, {
    key: "handleTheColumnClick",
    value: function handleTheColumnClick(event, index, columnProps) {
      if (this.props.thClickFocusClassName) {
        this.setState({
          thClickFocusKey: "".concat(index, "_").concat(columnProps.name)
        });
      }
    }
  }, {
    key: "setTableAttributeAndEvent",
    value: function setTableAttributeAndEvent() {
      var _this5 = this;

      var setTheadTableWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var mustClearTableWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var _getTableDOM4 = (0, _get_node.getTableDOM)(this),
          clientWidth = _getTableDOM4.clientWidth,
          len = _getTableDOM4.len;

      var _this$props9 = this.props,
          _this$props9$loading = _this$props9.loading,
          loading = _this$props9$loading === void 0 ? false : _this$props9$loading,
          children = _this$props9.children,
          _this$props9$totalLab = _this$props9.totalLabelColSpan,
          totalLabelColSpan = _this$props9$totalLab === void 0 ? 1 : _this$props9$totalLab,
          _this$props9$adjustWi = _this$props9.adjustWidthSync,
          adjustWidthSync = _this$props9$adjustWi === void 0 ? false : _this$props9$adjustWi,
          setAllBodyCellMaxMinWidth = _this$props9.setAllBodyCellMaxMinWidth;
      var cssFixedTotalAble = (0, _bool.isFixedTableTotalByCss)(this.props); // 触发下滚动条事件

      var triggerScrollEvent = function triggerScrollEvent() {
        if (_this5.tableWrap) {
          _this5.getScrollInfo();

          var target = classNameIndexOf(_this5.tableWrap, _index.tableFixedTheadClassName) < 0 ? _this5.tableWrap : _this5.tableTbodyWraper;

          _this5.bindScroll({
            target: target
          }, (0, _get_node.getColumns)(children), true);

          if (totalLabelColSpan > 1 && _this5.tbodyTable && _this5.tableTfootWraper) {
            var unFixedTfootNode = _this5.tbodyTable.getElementsByTagName('tfoot');

            var fixedTfootNode = _this5.tableTfootWraper.getElementsByTagName('tfoot');

            var curUnFixedTfootNode = unFixedTfootNode[0];
            var unFixedTfootTdList = curUnFixedTfootNode && curUnFixedTfootNode.getElementsByTagName('td') || [];
            var curFixedTfootNode = fixedTfootNode[0];
            var fixedTfootTdList = curFixedTfootNode && curFixedTfootNode.getElementsByTagName('td') || [];
            var unFixedTfootLength = unFixedTfootTdList.length;
            var i = 0;
            var fromTarget = null;
            var toTarget = null;

            if (unFixedTfootLength > 0 && unFixedTfootLength == fixedTfootTdList.length) {
              for (; i < unFixedTfootLength; i++) {
                fromTarget = unFixedTfootTdList[i];
                toTarget = fixedTfootTdList[i];

                if (fromTarget && fromTarget.getBoundingClientRect && toTarget) {
                  toTarget.style.minWidth = "".concat(fromTarget.getBoundingClientRect().width, "px");
                  toTarget.style.maxWidth = "".concat(fromTarget.getBoundingClientRect().width, "px");
                }
              }
            }
          }
        }
      };

      var oldTheadTableWidth = 0;

      if (this.tableWrap) {
        // 清空内容
        if (mustClearTableWidth) {
          (0, _set_size.clearTableWidth)((0, _get_node.getTableDOM)(this), {
            setAllBodyCellMaxMinWidth: setAllBodyCellMaxMinWidth
          });
        } // 固定头部或者尾部


        if ((0, _bool.isFixedTableThead)(this.props) || cssFixedTotalAble) {
          // 先设置表格总宽度，在设置单元格的宽度
          if (len > 0 && clientWidth > 0) {
            (0, _set_size.setTableWidthAndClassName)(this.props, (0, _get_node.getTableDOM)(this));
          }

          this.setTableCellWidth();
          oldTheadTableWidth = this.theadTable && this.theadTable.style.width;
          this.setTableAttributeWhenFixedThead(); // 固定头部尺寸要减去宽度

          if (setTheadTableWidth && this.theadTable && this.theadTable.getAttribute('data-fixedableThead')) {
            this.theadTable.style.width = "".concat(this.tbodyTable.clientWidth, "px");
          }

          if (!loading) {
            this.setTheadTableWidthWhenFixedThead(oldTheadTableWidth);

            if (adjustWidthSync) {
              this.adjustTheadTableAndTbodyTableWidth();
              triggerScrollEvent();
              this.setLoadingWidth(clientWidth);
            } else {
              // 延迟下等待报表都计算完了
              setTimeout(function () {
                _this5.adjustTheadTableAndTbodyTableWidth();

                triggerScrollEvent();

                _this5.setLoadingWidth(clientWidth);
              }, 4);
            }
          }
        } else {
          (0, _set_size.setTableWidthAndClassName)(this.props, (0, _get_node.getTableDOM)(this));
        }

        triggerScrollEvent();
        this.setLoadingWidth(clientWidth); // 将 table 的 clientWidth 作为一个 css 变量放置到 table 的外层上

        this.tableWrap.style.setProperty('--table-client-width', "".concat(this.tableWrap.clientWidth, "px"));
      }
    }
  }, {
    key: "adjustTheadTableAndTbodyTableWidth",
    value: function adjustTheadTableAndTbodyTableWidth() {
      var tableWidth = 0;
      var _this$props10 = this.props,
          data = _this$props10.data,
          loading = _this$props10.loading;

      if ((data.length === 0 && !loading || this.theadTable) && this.tbodyTable && this.tbodyWrap) {
        tableWidth = (0, _number.toInt)((0, _spauiUtils.getStyle)(this.tbodyTable, 'width'));
        var _this$props11 = this.props,
            children = _this$props11.children,
            adjustMinWidth = _this$props11.adjustMinWidth,
            minColumnWidth = _this$props11.minColumnWidth;
        var widthFromConfig = 0; // 没有数据的时候计算一下配置的列的宽度，避免显示不全

        if (data.length === 0 && !loading) {
          var columnsWidth = (0, _get_node.getColumns)(children).map(function (columnConfig) {
            var colProps = columnConfig.props;
            return {
              width: parseInt(colProps.width || colProps.minWidth || minColumnWidth || adjustMinWidth || 0, 10)
            };
          });
          widthFromConfig = Math.floor(columnsWidth.reduce(function (prev, cur) {
            return prev + cur.width;
          }, 0));
        }

        this.setWrapWidth(Math.max(tableWidth, widthFromConfig));
        (0, _set_size.setTheadTableCellWidthEqualTbodyTable)((0, _get_node.getTableDOM)(this), this.props);
      }
    }
  }, {
    key: "triggerSetTableAttributeAndEvent",
    value: function triggerSetTableAttributeAndEvent() {
      var _this6 = this;

      var isUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props12 = this.props,
          _this$props12$fixedTi = _this$props12.fixedTitle,
          fixedTitle = _this$props12$fixedTi === void 0 ? false : _this$props12$fixedTi,
          sortName = _this$props12.sortName,
          sortOrder = _this$props12.sortOrder,
          multiFieldSort = _this$props12.multiFieldSort;
      this.setTableAttributeAndEvent(!!isNeedClearTableWidth(prevProps, this.props), !isUpdate || isNeedClearTableWidth(prevProps, this.props)); // 如果是通过固定标题的形式来展示的话，要延迟一会设置宽高，因为有可能还没来得及展示

      if (!isUpdate || fixedTitle) {
        clearTimeout(this.triggerSetTableTimeout);
        this.triggerSetTableTimeout = setTimeout(function () {
          _this6.setTableAttributeAndEvent(true);
        }, 40);
      } else if (multiFieldSort ? sortName.length > 0 : sortName || sortOrder) {
        this.setTableAttributeAndEvent(true, !isUpdate || isNeedClearTableWidth(prevProps, this.props));
      }
    }
    /**
     * 获取控制宽度的colGroup
     * @private
     */

  }, {
    key: "getColGroup",
    value: function getColGroup(ref) {
      var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var _this$props13 = this.props,
          _this$props13$minColu = _this$props13.minColumnWidth,
          minColumnWidth = _this$props13$minColu === void 0 ? 0 : _this$props13$minColu,
          total = _this$props13.total,
          totalLabel = _this$props13.totalLabel;
      var result = '';
      result = _react["default"].createElement(_colgroup["default"], {
        total: total,
        totalLabel: totalLabel,
        htmlRef: ref,
        columns: columns,
        minColumnWidth: minColumnWidth
      });
      return result;
    }
  }, {
    key: "setTableCellWidth",
    value: function setTableCellWidth() {
      var _this$props$loading = this.props.loading,
          loading = _this$props$loading === void 0 ? false : _this$props$loading;

      var _getTableDOM5 = (0, _get_node.getTableDOM)(this),
          clientWidth = _getTableDOM5.clientWidth,
          len = _getTableDOM5.len;

      var setedWidth = 0;
      var setedLen = 0;
      var setColWidthResult = {};
      var updateCellWidthList = [];

      if (len > 0 && clientWidth > 0) {
        // 已经指定宽度的
        setColWidthResult = (0, _set_size.setCustomWidth)(setedWidth, setedLen, (0, _get_node.getTableDOM)(this), this.props);
        setedWidth = setColWidthResult.setedWidth;
        setedLen = setColWidthResult.setedLen;
        updateCellWidthList = updateCellWidthList.concat(setColWidthResult.cellList); // loading不计算实际宽度

        if (!loading) {
          // 处理一下可能实际td的宽度比计算的大的情况
          setColWidthResult = (0, _set_size.setRealWidthIsLargeThanTheCalWidth)(setedWidth, setedLen, (0, _get_node.getTableDOM)(this), this.props);
          setedWidth = setColWidthResult.setedWidth;
          setedLen = setColWidthResult.setedLen;
          updateCellWidthList = updateCellWidthList.concat(setColWidthResult.cellList);
        } // 剩下的平均分配


        var hasSetWidthIndexList = updateCellWidthList.map(function (item) {
          return item.index;
        });
        setColWidthResult = (0, _set_size.setCalWidth)(setedWidth, setedLen, (0, _get_node.getTableDOM)(this), this.props, hasSetWidthIndexList);
        updateCellWidthList = updateCellWidthList.concat(setColWidthResult.cellList); // 获取到宽度后统一设置，避免边设置边获取其它列的宽度

        updateCellWidthList.forEach(function (item) {
          var index = item.index,
              colWidth = item.colWidth,
              isCustomStyleWidth = item.isCustomStyleWidth,
              maxWidth = item.maxWidth,
              nodes = item.nodes,
              props = item.props;
          (0, _set_size.setCellWidthForTable)(index, colWidth, isCustomStyleWidth, maxWidth, nodes, props, true, {
            onlySetHead: loading
          });
        });
      }
    } // 固定头部时设置对应的宽度

  }, {
    key: "setTableAttributeWhenFixedThead",
    value: function setTableAttributeWhenFixedThead() {
      var fixedPlacement = this.props.fixedPlacement;
      var fixedRows = (0, _bool.getFixedRows)(this.props);
      var fixedHeight = (0, _bool.getFixedHeight)(this.props);

      var _fixedHeight = (0, _number.toInt)(fixedHeight);

      var tableHeight = this.tableWrap && (0, _number.toInt)(this.tableWrap.clientHeight) || 0;
      var theadHeight = this.theadTable && (0, _number.toInt)(this.theadTable.clientHeight) || 0;
      var isFixedTheadByHeight = _fixedHeight > 0 && _fixedHeight < tableHeight;
      var isFixedTheadByRows = fixedRows > 0;
      var tbodyHeight = 0;
      var tr = 0;
      var i = 0;
      var _tableWrapHeight = 0;
      var _tbodyHeight = 0;

      if (isFixedTheadByHeight) {
        _tableWrapHeight = _fixedHeight;
        _tbodyHeight = _fixedHeight - theadHeight;
      } else if (isFixedTheadByRows) {
        tr = this.tbodyWrap.getElementsByTagName('tr');

        for (; i < fixedRows; i++) {
          if (tr[i]) {
            tbodyHeight += tr[i].clientHeight;
          }
        }

        tbodyHeight = (0, _number.toInt)(tbodyHeight);
        _tableWrapHeight = theadHeight + tbodyHeight;
        _tbodyHeight = tbodyHeight;
      }

      if (isFixedTheadByHeight || isFixedTheadByRows) {
        (0, _set_position.setTableAttributeWhenFixedThead)(_tableWrapHeight, _tbodyHeight, fixedPlacement, {
          tableWrap: this.tableWrap,
          tbodyWrap: this.tbodyWrap,
          tableTbodyWraper: this.tableTbodyWraper,
          theadTable: this.theadTable,
          tbodyTable: this.tbodyTable
        });
      }
    }
  }, {
    key: "setTheadTableWidthWhenFixedThead",
    value: function setTheadTableWidthWhenFixedThead(oldTheadTableWidth) {
      var _this7 = this;

      var fixedRows = (0, _bool.getFixedRows)(this.props);
      var fixedHeight = (0, _bool.getFixedHeight)(this.props);

      var _fixedHeight = (0, _number.toInt)(fixedHeight);

      var tableHeight = this.tableWrap && (0, _number.toInt)(this.tableWrap.clientHeight) || 0;
      var isFixedTheadByHeight = _fixedHeight > 0 && _fixedHeight < tableHeight;
      var isFixedTheadByRows = fixedRows > 0;

      if (isFixedTheadByHeight || isFixedTheadByRows) {
        // 先用旧的，等计算好了再用新宽度
        if (oldTheadTableWidth && this.theadTable) {
          this.theadTable.style.width = oldTheadTableWidth;
        }

        setTimeout(function () {
          if (_this7.theadTable) {
            _this7.theadTable.style.width = "".concat(_this7.tbodyTable.clientWidth, "px");
          }
        }, 4);
      }
    } // 设置行的className

  }, {
    key: "setTrClassName",
    value: function setTrClassName(type, data) {
      var setTrClassName = this.props.setTrClassName;
      var result = '';

      if ((0, _spauiUtils.isFunction)(setTrClassName)) {
        result = setTrClassName(type, data);
      }

      return result;
    }
  }, {
    key: "renderFixedTitle",
    value: function renderFixedTitle(event) {
      var _this8 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var columns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var _this$props14 = this.props,
          renderFixedTitle = _this$props14.renderFixedTitle,
          fixedTitle = _this$props14.fixedTitle;

      var hideTitle = function hideTitle() {
        if (_this8.title) {
          _this8.title.innerHTML = '';
          _this8.title.style.display = 'none';
        }
      };

      var innerHTML = '';
      var result = {}; // 有title结构才可以固定

      if (this.title) {
        if ((0, _spauiUtils.isFunction)(renderFixedTitle) && event && event.target) {
          result = event; // 如果是页面的滚动条，固定title的left要用表格的scrollLeft

          if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && event.target === document && this.tableWrap) {
            result = {
              target: {
                scrollLeft: this.tableWrap.scrollLeft
              }
            };
          } // 必须返回的是html字符串，因为是通过innerHTML放入的


          innerHTML = renderFixedTitle(result, data, columns.length);

          if (innerHTML && fixedTitle) {
            if (this.title) {
              this.title.innerHTML = innerHTML;
              this.title.style.display = '';
            }
          } else {
            hideTitle();
          }
        } else {
          hideTitle();
        }
      }
    } // 用于外部固定标题

  }, {
    key: "setFixedTitle",
    value: function setFixedTitle(event, columnsArg) {
      var children = this.props.children;
      var columns = columnsArg || (0, _get_node.getColumns)(children);
      var _this$props$data = this.props.data,
          data = _this$props$data === void 0 ? [] : _this$props$data;
      var tr = [];
      var i = 0;
      var len = 0;
      var theadRect = {};
      var trRect = {};
      var theadTop = 0;
      var theStartTop = 0;
      var theEndTop = 0;
      var dataIndex = 0;

      if (event && event.target && this.theadTable && this.tbodyTable) {
        tr = this.tbodyTable.getElementsByTagName('tr') || [];
        len = tr.length;
        theadRect = this.theadTable.getBoundingClientRect() || {};
        theadTop = (theadRect.top || 0) + (theadRect.height || 0);

        for (; i < len; i++) {
          if (tr[i]) {
            trRect = tr[i].getBoundingClientRect() || {};
            theStartTop = trRect.top - theadTop - 1;
            theEndTop = theStartTop + trRect.height;

            if (theStartTop <= 0 && theEndTop > 0) {
              dataIndex = tr[i].getAttribute('data-index') || i;
              this.renderFixedTitle(event, data[dataIndex], columns);
            }
          }
        }
      }
    }
  }, {
    key: "bindScroll",
    value: function bindScroll(event) {
      var _this9 = this;

      var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var needUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props15 = this.props,
          fixedTitle = _this$props15.fixedTitle,
          expandComponentFixedable = _this$props15.expandComponentFixedable,
          fixedEmptyComponent = _this$props15.fixedEmptyComponent,
          fixedLoadingComponent = _this$props15.fixedLoadingComponent,
          _this$props15$data = _this$props15.data,
          data = _this$props15$data === void 0 ? [] : _this$props15$data;
      var cssFixedTotalAble = (0, _bool.isFixedTableTotalByCss)(this.props);
      var target = event && event.target || null;
      var targetRect = {};

      if (target && this.tableWrap) {
        var scrollLeft = target.scrollLeft;
        var originScrollLeft = scrollLeft; // 切换列的时候可能会出现target保留了上一次的滚动数据，导致实际占用宽度比tbody还多

        if (this.tbodyWrap && target && this.tbodyWrap.offsetWidth > 0 && target.scrollWidth > this.tbodyWrap.offsetWidth) {
          var maxScrollWidth = 0; // safari的scrollWidth 一直都会比offsetWidth大，两者不相等

          if (isSafari) {
            maxScrollWidth = Math.max(target.scrollWidth, this.tbodyWrap.offsetWidth) + 20;
          } else {
            maxScrollWidth = this.tbodyWrap.offsetWidth;
          } // 加起来比tbody的实际宽度还多，就需要调整一下scrollLeft


          if (target.offsetWidth + scrollLeft > maxScrollWidth) {
            scrollLeft = maxScrollWidth - target.offsetWidth;
          }
        }

        var isTfootWraper = classNameIndexOf(target, 'spaui-table-fixed-tfoot-wraper') > -1;

        if (isTfootWraper) {
          if (target && target.getBoundingClientRect) {
            targetRect = (0, _index2.getBoundingClientRect)(target); // 隐藏的滚动条是不会触发scrollLeft的

            if (targetRect.top < 50 || targetRect.top > window.innerHeight + 10) {
              return false;
            }
          }
        }

        var setCellFixed = function setCellFixed() {
          var cellFixedLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var fixedCellList = _this9.fixedCellList || []; // scrollLeft跟缓存标记的scrollLeft一样，说明已经设置过了，就不运行下面的了

          if (needUpdate || cellFixedLeft < 1 || cellFixedLeft !== _this9.scrollLeft || expandComponentFixedable || fixedEmptyComponent || fixedLoadingComponent) {
            fixedCellList.map(function () {
              var fixedCellItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var _fixedCellItem$column = fixedCellItem.columnCellList,
                  columnCellList = _fixedCellItem$column === void 0 ? [] : _fixedCellItem$column,
                  getLeft = fixedCellItem.getLeft,
                  _fixedCellItem$fixedC = fixedCellItem.fixedClassName,
                  fixedClassName = _fixedCellItem$fixedC === void 0 ? '' : _fixedCellItem$fixedC;
              var cellLeft = (0, _spauiUtils.isFunction)(getLeft) ? getLeft(cellFixedLeft) : 0;

              if (columnCellList.length > 0 && (0, _spauiUtils.isFunction)(columnCellList.map)) {
                columnCellList.map(function (item) {
                  var expendComponentNode = null;
                  var tableWrapRect = {};

                  if (item) {
                    if (((0, _number.getAttributeToNumber)(item, 'colspan') || 1) !== columns.length) {
                      (0, _set_position.setCellLeft)(item, cellLeft, fixedClassName);
                    } else if (_this9.tableWrap && item.getAttribute('data-fixed') === '1') {
                      // 固定的扩展行
                      tableWrapRect = (0, _index2.getBoundingClientRect)(_this9.tableWrap);
                      expendComponentNode = item.getElementsByTagName('div')[0];
                      (0, _set_position.setCellLeft)(item, 0, fixedClassName);

                      if (tableWrapRect.width && expendComponentNode) {
                        expendComponentNode.style.width = "".concat(tableWrapRect.width - (0, _number.toInt)((0, _spauiUtils.getStyle)(item, 'padding-left')) - (0, _number.toInt)((0, _spauiUtils.getStyle)(item, 'padding-right')), "px");
                        expendComponentNode.style.position = 'relative';
                        expendComponentNode.style.left = "".concat(cellLeft, "px");
                      }
                    }
                  }

                  return item;
                });
              }

              return fixedCellItem;
            }); // 记录下当前的scrollLeft是多少

            _this9.scrollLeft = cellFixedLeft;
          }
        };

        var settPositioSync = function settPositioSync() {
          var tableTfootWraperRect = {};
          var tableTfootWraperIsFixed = false; // scrollLeft跟缓存标记的scrollLeft一样，说明已经设置过了，就不运行下面的了

          if (needUpdate || scrollLeft < 1 || scrollLeft !== _this9.scrollLeft || expandComponentFixedable || fixedEmptyComponent || fixedLoadingComponent) {
            // 设置偏移
            (0, _set_position.setWrapLeft)(_this9, -scrollLeft, isTfootWraper); // 固定头部的时候，因为头部是另外一个table，要做下滚动条偏移
            // 用className判断是因为通过高度固定头部，固定后高度会变化，通过高度再判断可能会不准确

            if (classNameIndexOf(_this9.tableWrap, _index.tableFixedTheadClassName) > -1 && _this9.theadWrap) {
              _this9.theadWrap.style.left = "".concat(-scrollLeft, "px");
            } // tfooter wraper滚动，主表格要做滚动偏移


            if (isTfootWraper) {
              // 主体滚动的一直都是最外层的table
              _this9.tableWrap.scrollLeft = scrollLeft; // table 最外层wrap滚动
            } else {
              // 尾部结构是css fixed中，主表格滚动，尾部要做偏移
              if (cssFixedTotalAble && _this9.tableTfootWraper && _this9.tableTfootWraper.getBoundingClientRect) {
                tableTfootWraperRect = (0, _index2.getBoundingClientRect)(_this9.tableTfootWraper); // 位置超过页面高度了

                if (tableTfootWraperRect.top <= Math.max(window.outerHeight, document.body.offsetHeight)) {
                  tableTfootWraperIsFixed = true;
                }
              } // 尾部单独结构css固定的时候


              if (tableTfootWraperIsFixed && _this9.tableTfootWraper) {
                _this9.tableTfootWraper.scrollLeft = scrollLeft;
              }
            } // 只有固定标题，且开启了才有


            if (fixedTitle && (0, _bool.isFixedTableThead)(_this9.props)) {
              _this9.setFixedTitle(event, columns);
            } else if (_this9.title) {
              // 没固定就隐藏
              _this9.title.style.display = 'none';
            }
          }
        }; // 固定空数据组件


        var setFixedEmptyComponent = function setFixedEmptyComponent() {
          if (_this9.emptyDataNode && _this9.tableWrap && fixedEmptyComponent) {
            var tableWrapRect = (0, _index2.getBoundingClientRect)(_this9.tableWrap);

            var emptyInnerNode = _this9.emptyDataNode.getElementsByTagName('div')[0];

            if (tableWrapRect.width && emptyInnerNode) {
              emptyInnerNode.style.width = "".concat(tableWrapRect.width - (0, _number.toInt)((0, _spauiUtils.getStyle)(_this9.emptyDataNode, 'padding-left')) - (0, _number.toInt)((0, _spauiUtils.getStyle)(_this9.emptyDataNode, 'padding-right')), "px");
              emptyInnerNode.style.position = 'relative';
              emptyInnerNode.style.left = "".concat(originScrollLeft, "px");
            }
          }
        };

        (function () {
          // IE 11 某些情况还是会报错，先 catch 下
          if (isLowerIEEdge) {
            try {
              settPositioSync();
            } catch (_error) {}
          } else {
            settPositioSync();
          }
        })();

        if (data.length > 0) {
          setCellFixed(scrollLeft);
        }

        setFixedEmptyComponent();
      }
    } // 是否使用隐藏滚动条的固定列方式

  }, {
    key: "setCellFixedUseHideScrollBar",
    value: function setCellFixedUseHideScrollBar() {
      var fixedCellList = this.fixedCellList || [];
      var _this$props$hideScrol = this.props.hideScrollBar,
          hideScrollBar = _this$props$hideScrol === void 0 ? false : _this$props$hideScrol;
      var cssFixedTotalAble = (0, _bool.isFixedTableTotalByCss)(this.props);
      var fixedRows = (0, _bool.getFixedRows)(this.props);
      var fixedHeight = (0, _bool.getFixedHeight)(this.props);
      var cssFixedTheadAble = (0, _bool.isFixedTableTheadByCss)(this.props);
      var result = false;
      var haveScrollBar = false;

      if (cssFixedTheadAble || cssFixedTotalAble || fixedRows < 1 && fixedHeight < 1) {
        if (this.tableWrap && this.tableWrap.scrollWidth > this.tableWrap.clientWidth) {
          haveScrollBar = true;
        }
      } else {
        if (this.tableTbodyWraper && this.tableTbodyWraper.scrollWidth > this.tableTbodyWraper.clientWidth) {
          haveScrollBar = true;
        }
      } // 高清屏隐藏滚动条然后通过滚动的距离来做偏移


      if (fixedCellList.length > 0 && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.devicePixelRatio !== 'undefined' && window.devicePixelRatio > 1 && haveScrollBar) {
        result = true;
      } // 如果指明隐藏滚动条，那就是false


      if (hideScrollBar) {
        result = false;
      }

      return result;
    } // 处理滚轮

  }, {
    key: "handleWheel",
    value: function handleWheel(event) {
      var _this10 = this;

      var isTfoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var children = this.props.children;
      var fixedRows = (0, _bool.getFixedRows)(this.props);
      var fixedHeight = (0, _bool.getFixedHeight)(this.props);
      var cssFixedTheadAble = (0, _bool.isFixedTableTheadByCss)(this.props);
      var cssFixedTotalAble = (0, _bool.isFixedTableTotalByCss)(this.props);
      var scrollTarget = null;

      if (isTfoot) {
        scrollTarget = this.tableTfootWraper;
      } else if (cssFixedTheadAble || cssFixedTotalAble || fixedRows < 1 && fixedHeight < 1) {
        scrollTarget = this.tableWrap;
      } else {
        scrollTarget = this.tableTbodyWraper;
      } // 高清屏隐藏滚动条然后通过滚动的距离来做偏移


      if (this.setCellFixedUseHideScrollBar() && scrollTarget) {
        var maxScrollLeft = scrollTarget.scrollWidth - scrollTarget.clientWidth;
        var deltaX = event.deltaX;

        var setWheelScrollTarget = function setWheelScrollTarget() {
          if (!_this10.countOfDeltaXIsOne) {
            _this10.countOfDeltaXIsOne = 0;
          }

          if (deltaX === 1) {
            _this10.countOfDeltaXIsOne += 1;
          }
        };

        var resetWheelScrollTarget = function resetWheelScrollTarget() {
          _this10.countOfDeltaXIsOne = 0;
        };

        var lastScrollLeft = scrollTarget.scrollLeft;
        var scrollLeft = lastScrollLeft; // 获取需要滚动多少

        scrollLeft += deltaX;

        if (scrollLeft > maxScrollLeft) {
          scrollLeft = maxScrollLeft;
        } else if (scrollLeft < 0) {
          scrollLeft = 0;
        }

        if (lastScrollLeft !== scrollLeft) {
          setWheelScrollTarget();
          scrollTarget.scrollLeft = scrollLeft;
          this.bindScroll({
            target: scrollTarget
          }, (0, _get_node.getColumns)(children), true);
          clearTimeout(this.wheelTargetTimeout); // 没滚多少，就去除了

          if (Math.abs(deltaX) < 2 && this.countOfDeltaXIsOne > 1) {
            resetWheelScrollTarget();
          } else {
            // timeout用40ms时候mac滚轮基本不会大于40ms，但是存在30多ms的情况
            this.wheelTargetTimeout = setTimeout(function () {
              resetWheelScrollTarget();
            }, 40);
          }
        }
      }
    } // 获取表格的foot内容

  }, {
    key: "getTableTfoot",
    value: function getTableTfoot() {
      var _this11 = this;

      var _this$props16 = this.props,
          loading = _this$props16.loading,
          total = _this$props16.total,
          propsData = _this$props16.data,
          filterName = _this$props16.filterName,
          filterValue = _this$props16.filterValue; // 筛选数据

      var data = (0, _get_data.getDataByFilterValue)(propsData, filterName, filterValue);
      var result = null; // 公共的tfoot

      if (total && data.length > 0 && !loading) {
        result = _react["default"].createElement(_tfoot_component["default"], _extends({}, this.props, {
          htmlRef: function htmlRef(el) {
            _this11.tfoot = el;
          }
        }));
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this12 = this,
          _objectSpread2;

      var _this$props17 = this.props,
          loading = _this$props17.loading,
          loadingType = _this$props17.loadingType,
          _this$props17$onClick = _this$props17.onClickTr,
          onClickTr = _this$props17$onClick === void 0 ? _spauiUtils.noop : _this$props17$onClick,
          _this$props17$onMouse = _this$props17.onMouseOverTr,
          onMouseOverTr = _this$props17$onMouse === void 0 ? _spauiUtils.noop : _this$props17$onMouse,
          _this$props17$onMouse2 = _this$props17.onMouseOutTr,
          onMouseOutTr = _this$props17$onMouse2 === void 0 ? _spauiUtils.noop : _this$props17$onMouse2,
          theadWraperStyle = _this$props17.theadWraperStyle,
          total = _this$props17.total,
          propsLoadingComponent = _this$props17.LoadingComponent,
          _this$props17$childre = _this$props17.children,
          children = _this$props17$childre === void 0 ? null : _this$props17$childre,
          propsData = _this$props17.data,
          filterName = _this$props17.filterName,
          filterValue = _this$props17.filterValue,
          _this$props17$hideScr = _this$props17.hideScrollBar,
          hideScrollBar = _this$props17$hideScr === void 0 ? false : _this$props17$hideScr,
          fixedTitleClassName = _this$props17.fixedTitleClassName,
          fixedTitleStyle = _this$props17.fixedTitleStyle,
          loadingTrClassName = _this$props17.loadingTrClassName,
          _this$props17$topSpac = _this$props17.topSpaceElement,
          topSpaceElement = _this$props17$topSpac === void 0 ? null : _this$props17$topSpac,
          _this$props17$bottomS = _this$props17.bottomSpaceElement,
          bottomSpaceElement = _this$props17$bottomS === void 0 ? null : _this$props17$bottomS,
          onBodyScroll = _this$props17.onBodyScroll,
          fixedTotalNoUseColGroup = _this$props17.fixedTotalNoUseColGroup,
          hideBodyTotal = _this$props17.hideBodyTotal,
          _this$props17$useOldC = _this$props17.useOldClass,
          useOldClass = _this$props17$useOldC === void 0 ? true : _this$props17$useOldC,
          style = _this$props17.style,
          cellPadding = _this$props17.cellPadding,
          firstCellPadding = _this$props17.firstCellPadding,
          lastCellPadding = _this$props17.lastCellPadding,
          cellHeight = _this$props17.cellHeight,
          theadCellHeight = _this$props17.theadCellHeight,
          tfootCellHeight = _this$props17.tfootCellHeight,
          theadBg = _this$props17.theadBg,
          borderColor = _this$props17.borderColor,
          cellBorderColor = _this$props17.cellBorderColor,
          trHoverBg = _this$props17.trHoverBg;
      var columns = (0, _get_node.getColumns)(children);
      var cssFixedTheadAble = (0, _bool.isFixedTableTheadByCss)(this.props);
      var cssFixedTotalAble = (0, _bool.isFixedTableTotalByCss)(this.props);
      var data = (0, _get_data.getDataByFilterValue)(propsData, filterName, filterValue);
      var trType = 'loading';
      var LoadingComponent = propsLoadingComponent || _loading_component["default"];
      var CoverLoadingComponent = propsLoadingComponent || _cover_loading_component["default"];
      var tableTbody = null;
      var tableTfoot = null;
      var totalDivStyle = {}; // 列都不传，不返回内容

      if (columns.length < 1) {
        return null;
      } // 表格尾部


      tableTfoot = this.getTableTfoot(); // 需要横向滚动条但是又不需要总计，所以把总计table隐藏了

      if (cssFixedTotalAble && !total) {
        totalDivStyle = {
          visibility: 'hidden',
          height: (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.devicePixelRatio !== 'undefined' && window.devicePixelRatio > 1 ? '10px' : '1px',
          overflow: 'hidden'
        };
      } // 是否loading的tableTbody


      if (loading && loadingType !== 'cover') {
        tableTbody = _react["default"].createElement(_loading_tbody_component["default"], _extends({}, this.props, {
          htmlRef: function htmlRef(el) {
            _this12.loadingDiv = el;
          },
          className: "".concat(this.setTrClassName(trType), " ").concat(loadingTrClassName),
          onClick: function onClick(event) {
            return onClickTr(event, trType);
          },
          onMouseOver: function onMouseOver(event) {
            return onMouseOverTr(event, trType);
          },
          onMouseOut: function onMouseOut(event) {
            return onMouseOutTr(event, trType);
          },
          LoadingComponent: LoadingComponent,
          columns: columns,
          TableProps: this.props
        }));
      } else {
        tableTbody = data.length < 1 ? _react["default"].createElement(_empty_component["default"], _extends({}, this.props, {
          emptyDataNodeRef: function emptyDataNodeRef(el) {
            _this12.emptyDataNode = el;
          }
        })) : _react["default"].createElement(_tbody_component["default"], _extends({}, this.props, {
          htmlRef: function htmlRef(el) {
            _this12.tbody = el;
          },
          tableWrap: this.tableWrap
        }));
      }

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-table', {
          'spaui-table-wraper table-wraper': useOldClass,
          'spaui-table-cssfixedthead': cssFixedTheadAble,
          'spaui-table-adjust-width': (0, _bool.isAdjustWidth)(this),
          'spaui-table-wraper-unscroll': hideScrollBar,
          'spaui-table-loading-cover': this.props.loading && this.props.loadingType === 'cover'
        })
      }, Table), {
        ref: function ref(el) {
          _this12.tableWrap = el;
        },
        onScroll: function onScroll(event) {
          return _this12.bindScroll(event, columns);
        },
        style: _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, '--table-cell-padding', cellPadding), _defineProperty(_objectSpread2, '--cell-padding', cellPadding), _defineProperty(_objectSpread2, '--first-cell-padding', firstCellPadding), _defineProperty(_objectSpread2, '--last-cell-padding', lastCellPadding), _defineProperty(_objectSpread2, '--cell-height', cellHeight), _defineProperty(_objectSpread2, '--thead-cell-height', theadCellHeight), _defineProperty(_objectSpread2, '--tfoot-cell-height', tfootCellHeight), _defineProperty(_objectSpread2, '--thead-bg', theadBg), _defineProperty(_objectSpread2, '--border-color', borderColor), _defineProperty(_objectSpread2, '--cell-border-color', cellBorderColor), _defineProperty(_objectSpread2, '--tr-hover-bg', trHoverBg), _objectSpread2), style)
      }), // 固定头部的结构
      (0, _bool.isFixedTableThead)(this.props) ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spaui-table-thead-wraper', {
          'spaui-table-fixed-thead-wraper': cssFixedTheadAble,
          'thead-table-wrapper': useOldClass
        }),
        ref: function ref(el) {
          _this12.tableTheadWraper = el;
        },
        style: theadWraperStyle
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spaui-table-thead', {
          'thead-table': useOldClass
        }),
        ref: function ref(el) {
          _this12.theadWrap = el;
        },
        style: isSafari && cssFixedTheadAble ? {
          overflow: 'visible'
        } : {}
      }, _react["default"].createElement("table", {
        className: (0, _classname.getTableClassName)(this.props),
        ref: function ref(el) {
          _this12.theadTable = el;
        }
      }, this.getColGroup(function (el) {
        _this12.theadColGroup = el;
      }, columns), _react["default"].createElement(_thead_component["default"], _extends({}, this.props, {
        thClickFocusKey: this.state.thClickFocusKey,
        filterSelectOpen: this.state.filterSelectOpen,
        onFilterSelectOpen: this.handleFilterSelectOpen,
        htmlRef: function htmlRef(el) {
          _this12.thead = el;
        },
        titleRef: function titleRef(el) {
          _this12.title = el;
        },
        fixedTitleClassName: fixedTitleClassName,
        fixedTitleStyle: fixedTitleStyle,
        onColumnMouseDown: this.handleTheadColumnMouseDown,
        onThMouseOver: this.handleThColumnMouseOver,
        onThMouseOut: this.handleThColumnMouseOut,
        onThClick: this.handleTheColumnClick
      }))))) : null, _react["default"].createElement("div", {
        // tbody 结构
        className: (0, _classnames["default"])('spaui-table-tbody-wraper', {
          'tbody-table-wrapper': useOldClass
        }),
        ref: function ref(el) {
          _this12.tableTbodyWraper = el;
        },
        onScroll: function onScroll(event) {
          _this12.bindScroll(event, columns);

          if ((0, _spauiUtils.isFunction)(onBodyScroll)) {
            var bodyScrollTop = event.target.scrollTop;
            var bodyVisibleHeight = event.target.clientHeight;
            var bodyScrollHeight = event.target.scrollHeight;
            onBodyScroll(event, [bodyScrollTop, bodyScrollTop + bodyVisibleHeight], bodyScrollHeight);
          }
        },
        onWheel: function onWheel(event) {
          return _this12.handleWheel(event);
        }
      }, topSpaceElement, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spaui-table-tbody', {
          'tbody-table': useOldClass
        }),
        ref: function ref(el) {
          _this12.tbodyWrap = el;
        }
      }, _react["default"].createElement("table", {
        className: (0, _classname.getTableClassName)(this.props),
        ref: function ref(el) {
          _this12.tbodyTable = el;
        }
      }, // 固定表头或者表尾，需要col
      (0, _bool.isFixedTableThead)(this.props) || cssFixedTotalAble ? this.getColGroup(function (el) {
        _this12.tbodyColGroup = el;
      }, columns) : null, !(0, _bool.isFixedTableThead)(this.props) ? _react["default"].createElement(_thead_component["default"], _extends({}, this.props, {
        thClickFocusKey: this.state.thClickFocusKey,
        htmlRef: function htmlRef(el) {
          _this12.thead = el;
        },
        onColumnMouseDown: this.handleTheadColumnMouseDown,
        onThMouseOver: this.handleThColumnMouseOver,
        onThMouseOut: this.handleThColumnMouseOut,
        filterSelectOpen: this.state.filterSelectOpen,
        onFilterSelectOpen: this.handleFilterSelectOpen,
        onThClick: this.handleTheColumnClick
      })) : null, tableTbody, hideBodyTotal ? null : tableTfoot), loading && loadingType === 'cover' ? _react["default"].createElement(CoverLoadingComponent, this.props) : null), bottomSpaceElement), // 固定tfoot是多加一个结构
      cssFixedTotalAble ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spaui-table-fixed-tfoot-wraper  spaui-table-fixed-tfoot-wraper', {
          'fixed-table-tfoot-wraper': useOldClass
        }),
        ref: function ref(el) {
          _this12.tableTfootWraper = el;
        },
        onScroll: function onScroll(event) {
          return _this12.bindScroll(event, columns);
        },
        onWheel: function onWheel(event) {
          return _this12.handleWheel(event, true);
        }
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spaui-table-tfoot', {
          'tfoot-table': useOldClass
        }),
        ref: function ref(el) {
          _this12.tfootWrap = el;
        },
        style: totalDivStyle
      }, _react["default"].createElement("table", {
        className: (0, _classname.getTableClassName)(this.props),
        ref: function ref(el) {
          _this12.tfootTable = el;
        }
      }, fixedTotalNoUseColGroup ? null : this.getColGroup(function (el) {
        _this12.tfootColGroup = el;
      }, columns), tableTfoot))) : null);
    }
  }]);

  return Table;
}(_react.PureComponent); // 组件标记


_defineProperty(Table, "propTypes", _table_props.propTypes);

_defineProperty(Table, "defaultProps", _table_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Table, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Table;
exports["default"] = _default;